import React from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  helper?: string;
  error?: string;
  children: React.ReactNode;
  htmlFor?: string;
}

export default function FormField({
  label,
  required,
  helper,
  error,
  children,
  htmlFor,
}: FormFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={htmlFor}
        className="text-sm font-semibold"
        style={{ color: 'var(--foreground)' }}
      >
        {label}
        {required && (
          <span className="ml-1" style={{ color: '#a34f42' }}>
            *
          </span>
        )}
      </label>

      {helper && (
        <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
          {helper}
        </p>
      )}

      {children}

      {error && (
        <p className="text-xs font-medium" style={{ color: '#a34f42' }}>
          {error}
        </p>
      )}
    </div>
  );
}